import { ITableCell, ITableRow } from "entities/TableStorage/sdk";

/**
 * This method is used to convert the data that is pasted into an expected format Array<Array<ITableCell>>.
 * Each row in the array represents a row in the table, and each element in the row represents a cell in the table.
 * It's possible to have a new line in some cell, so we need to handle that case. Otherwise, we are using the new line to separate the rows.
 */
export const convertPastedDataToTableRows = ({
  data,
}: {
  data: string;
}): Array<ITableRow> => {
  const tableDataRows: Array<ITableRow> = [];
  let currentRowCells: Array<ITableCell> = [];
  let withinQuotes = false;
  let currentCell = "";

  [...data].forEach((char) => {
    if (char === '"') {
      withinQuotes = !withinQuotes;
    } else if (char === "\n" && !withinQuotes) {
      currentRowCells.push({ value: currentCell.trim() });
      tableDataRows.push({ cells: currentRowCells });
      currentRowCells = [];
      currentCell = "";
    } else if (char === "\t" && !withinQuotes) {
      currentRowCells.push({ value: currentCell.trim() });
      currentCell = "";
    } else {
      currentCell += char;
    }
  });

  // Add the last cell to the current row
  currentRowCells.push({ value: currentCell.trim() });
  tableDataRows.push({ cells: currentRowCells });

  return tableDataRows;
};
